<div class="manual-address-entry">
	<form [formGroup]="_form">
		<div class="row">
			<div class="col-md-4 margin-bottom" *ngIf="_showFullSearch">
				<tc-auto-complete-form-field
					[controlName]="'unitType'"
					[label]="'Unit type'"
					[placeholder]="'e.g. Unit'"
					[displayProperty]="'Value'"
					[options]="_unitTypes"
					(event)="_unitTypeEventHandler($event, 0)"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[0].Value"
					[appearance]="_appearance"
					[maxLength]="128"
				>
				</tc-auto-complete-form-field>
			</div>
			<div [ngClass]="_showFullSearch ? 'col-md-4 margin-bottom' : 'col-md-6 margin-bottom'">
				<tc-input-form-field
					(event)="_checkTick($event, 1)"
					[controlName]="'unitNo'"
					[label]="_showFullSearch ? 'Unit #' : 'Unit number'"
					[errorFn]="_handleUnitNoError"
					[placeholder]="'e.g. 1'"
					[required]="_unitNoRequired"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[1].Value"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-4 margin-bottom" *ngIf="_showFullSearch">
				<tc-input-form-field
					(event)="_checkTick($event, 2)"
					[controlName]="'unitNoSuffix'"
					[errorFn]="_handleUnitNoError"
					[label]="'Unit # S'"
					[placeholder]="'e.g. A'"
					[maxLength]="1"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[2].Value"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-input-form-field
					(event)="_checkTick($event, 3)"
					[controlName]="'streetNo'"
					[label]="'Street number'"
					[placeholder]="'e.g. 1'"
					[required]="false"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[3].Value"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-6 margin-bottom" *ngIf="_showFullSearch">
				<tc-input-form-field
					(event)="_checkTick($event, 4)"
					[controlName]="'streetNoSuffix'"
					[label]="'Street # S'"
					[placeholder]="'e.g. A'"
					[maxLength]="1"
					[errorFn]="_handleStreetNoError"
					[validImage]="_validImage"
					[required]="false"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[4].Value"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-input-form-field
					(event)="_checkTick($event, 5)"
					[controlName]="'streetName'"
					[label]="'Street name'"
					[placeholder]="'Format: e.g. Flinders'"
					[errorFn]="_handleStreetNameError"
					[required]="true"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[5].Value"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-auto-complete-form-field
					[label]="'Street type'"
					[controlName]="'streetType'"
					[placeholder]="'e.g. Road'"
					[options]="_streetTypes"
					[displayProperty]="'Value'"
					[required]="true"
					(event)="_genericAutoCompleteEventHandler($event, 6)"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[6].Value"
					[appearance]="_appearance"
					[maxLength]="128"
				></tc-auto-complete-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-auto-complete-form-field
					[controlName]="'postcode'"
					[label]="'Post code'"
					[placeholder]="'e.g. Melbourne / 3000'"
					[displayFn]="_postcodeDisplayFn"
					[charThreshold]="2"
					[required]="true"
					[optionDisplayFn]="_postcodeOptionDisplayFn"
					[displayProperty]="'Value'"
					[options$]="_postcodesOb"
					(event)="_postcodeAutoCompleteEventHandler($event, 7)"
					[maxLength]="4"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[voidValidImage]="_voidImages[7].Value"
					[appearance]="_appearance"
				></tc-auto-complete-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-input-form-field
					[controlName]="'suburb'"
					[label]="'Suburb'"
					[required]="true"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
			<div class="col-md-6 margin-bottom">
				<tc-input-form-field
					[controlName]="'state'"
					[label]="'State'"
					[required]="true"
					[validImage]="_validImage"
					[invalidImage]="_invalidImage"
					[appearance]="_appearance"
				></tc-input-form-field>
			</div>
		</div>
	</form>

	<!-- <div class="error" *ngIf="error?.msg">{{error?.msg}}</div> -->
	<!--  
		Full Search Toggle
	-->
	<div class="row">
		<button class="full-search col-md-12" (click)="_toggleFullSearch()">
			<div>
				<p *ngIf="_showFullSearch">Hide full address search</p>
				<p *ngIf="!_showFullSearch">Show full address search</p>
			</div>
			<div [ngClass]="_showFullSearch? 'up' : 'down'"></div>
		</button>
	</div>
</div>
